import React from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { DropzoneDialog } from 'mui-file-dropzone';

export const UploadImagesForNewEquipmentDialog = () => {
  const { isOpen, handleClose, data } = useModal(ModalsKeys.UploadImagesForNewEquipmentDialog);

  const onSave = (files: File[]) => {
    data.onSave(files);
    handleClose();
  };

  return (
    <DropzoneDialog
      fullWidth
      maxWidth="lg"
      open={isOpen}
      filesLimit={5}
      onSave={onSave}
      fileObjects={[]}
      onClose={handleClose}
      maxFileSize={25000000}
      cancelButtonText="Cancel"
      submitButtonText="Submit"
      dialogTitle="Upload Equipment Images"
      acceptedFiles={['image/jpeg', 'image/png']}
    />
  );
};
